export const CASH = 'Cash';
export const TOURNAMENT = 'Tournament';
export const NO_LIMIT = 'No Limit';
export const LIMIT = 'Limit';
export const SPREAD_LIMIT = 'Spread Limit';
export const POT_LIMIT = 'Pot Limit';

export const HANDS_PER_HOUR = 27;
export const HANDS_PER_HOUR_ONLINE = 35;

export const isProduction = process.env.NODE_ENV === 'production';

export const GAMES_DB = 'GamesList';
export const PLACES_DB = 'PlaceList';
export const BETTYPES_DB = 'BetTypesList';
export const SESSIONS_DB = isProduction ? 'Sessions' : 'Sessiontest';
export const USERS_DB =  'users' ;
export const TOURNAMENT_SETTINGS_DB = isProduction ? 'tournamentSettings' : 'tournamentSettingsTest';
export const TOURNAMENT_PLAYERS_DB = isProduction ? 'tournamentPlayers' : 'tournamentPlayersTest';
export const TOURNAMENT_PAYOUTS_DB = isProduction ? 'tournamentPayouts' : 'tournamentPayoutsTest';
export const TOURNAMENT_TIMERS_DB = isProduction ? 'tournamentTimers' : 'tournamentTimersTest';
export const SAVED_TOURNAMENT_RESULTS_DB = isProduction ? 'savedTournamentResults' : 'savedTournamentResultsTest';
export const TOURNAMENT_STRUCTURES_DB = 'tournamentStructures' ;
export const LEAGUES_DB = isProduction ? 'leagues' : 'leaguesTest';
export const FEEDBACK_DB = isProduction ? 'feedback' : 'feedbackTest';

export const BET_TYPE_LIST_PICKER = [NO_LIMIT, LIMIT, SPREAD_LIMIT, POT_LIMIT];
export const TYPE_LIST_PICKER = [{ value: null, text: 'Please Select an Option' }, CASH, TOURNAMENT];

export const ENTER_SESSION = 'Enter Session';
export const SHOW_GRAPH = 'Show Graph';
export const EDIT_SESSIONS = 'Edit Sessions';
export const SHOW_PLACES = 'Show Places';
export const SHOW_DAYS = 'Show Days';